import { DIAL_CODE_TO_ISO2_MAP } from "./countries-data";

/**
 * Converts a country dial code (e.g., "+93") to ISO2 country code (e.g., "af")
 * @param dialCode - The country calling code with or without the "+" prefix
 * @returns The ISO2 country code or null if not found
 */
export function getCountryCodeFromDialCode(dialCode: string): string | null {
  if (!dialCode) {
    return null;
  }

  const cleanedDialCode = dialCode.replace(/^\+/, '');
  return DIAL_CODE_TO_ISO2_MAP[cleanedDialCode] || null;
}
